import { Pipe, PipeTransform } from '@angular/core';
import { Attendee } from '../domain/registrator';

@Pipe({
  name: 'attendeeListFormatter',
  standalone: true
})
export class AttendeeListFormatterPipe implements PipeTransform {

  transform(attendees: Attendee[]): string {
    if (!attendees || attendees.length === 0) {
      return 'None';
    }

    return attendees
      .sort((a, b) => 
        a.lastName.localeCompare(b.lastName) || a.firstName.localeCompare(b.firstName))
      .map(attendee => `${attendee.firstName} ${attendee.lastName}${attendee.corresponding ? '*' : ''}`)
      .join(', ');
  }

}
